import { HttpCode } from './http-code';
export var NETWORK_CONNECTION_ERROR = 1;
export var UNKNOWN_RESPONSE_ERROR = 2;
export var SERVER_RESPONSE_ERROR = 3;
export var CLIENTS_ONLY_MESSAGES = {
    1: 'Could not connect to server.'
};
var CwError = (function () {
    function CwError(code, message, request, response, source) {
        this.code = code;
        this.message = message;
        this.request = request;
        this.response = response;
        this.source = source;
    }
    return CwError;
}());
export { CwError };
// tslint:disable-next-line:only-arrow-functions
export function isSuccess(resp) {
    return resp.status > 199 && resp.status < 300;
}
// tslint:disable-next-line:only-arrow-functions
export function hasContent(resp) {
    return isSuccess(resp) && resp.status !== HttpCode.NO_CONTENT;
}
//# sourceMappingURL=http-response-util.js.map